// extracted by mini-css-extract-plugin
export default {"trips-list-error":"styles_trips-list-error__S6Di3"};